import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS, ROLES, ROUTES } from '../../../constants';
import { Delete, ViewIcon } from '../../../assets/svg';
import { DeleteConfirmationModal } from '../../shared';
import { deleteAccountReviewAPI } from '../../../utils/apiServices/accountReviewAPI';
import { popup } from '../../../utils';

const AccountReviewAction = ({ id, name, title, accountId }) => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const role = useSelector((s) => s.user?.role);
    const isUser = role === ROLES.USER;
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const hasPrivileges = [ROLES.ADMIN, ROLES.CSM, ROLES.SUPER_ADMIN].includes(role);

    const viewHandler = () => {
        navigate(isUser ? ROUTES.CUSTOMER.ACCOUNT_REVIEW_PAGE : ROUTES.ADMIN.ACCOUNT_REVIEW_PAGE, {
            state: { accountReviewId: id, name, title, accountId },
        });
    };

    const deleteMutation = useMutation({
        mutationFn: async (selectedItemId) => await deleteAccountReviewAPI({ id: selectedItemId }),
        onSuccess: ({ message }) => {
            popup('success', message);
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.ACCOUNT_REVIEWS],
                exact: false,
            });
            setIsDeleteModalOpen(false);
        },
        onError: (error) => popup('error', error.message),
    });

    const deleteHandler = async ({ selectedItemId }) => {
        deleteMutation.mutate(selectedItemId);
    };

    return (
        <div className='d-flex gap-2'>
            <button
                type='button'
                title={'View Account Review'}
                id='action-btn'
                onClick={viewHandler}
            >
                <ViewIcon />
            </button>
            {hasPrivileges && (
                <>
                    <button
                        type='button'
                        title={'Delete Account Review'}
                        id='action-btn-red'
                        onClick={() => setIsDeleteModalOpen(true)}
                    >
                        <Delete stroke='#ff004d' />
                    </button>
                    {isDeleteModalOpen && (
                        <DeleteConfirmationModal
                            isDeleteModal={isDeleteModalOpen}
                            setIsDeleteModal={setIsDeleteModalOpen}
                            selectedItemId={id}
                            handleDeleteClick={deleteHandler}
                            deleteButtonName={title}
                            isLoading={deleteMutation.isPending}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default AccountReviewAction;
